import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrimDirective } from './trim.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule} from '@angular/material/card'
import { MatMenuModule} from '@angular/material/menu';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatIconModule} from '@angular/material/icon';
import { CurrencyPipe } from '@angular/common';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatGridListModule} from '@angular/material/grid-list';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import { MatButtonModule} from '@angular/material/button';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { DateAdapter} from '@angular/material/core';
import { NativeDateModule} from '@angular/material/core';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogModule} from '@angular/material/dialog';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule} from '@angular/material/list';

import { PersonDataFormComponent } from './components/person-data-form/person-data-form.component';
import { PersonFormComponent } from './components/person-form/person-form.component';
import { CompanyFormComponent } from './components/company-form/company-form.component';
import { CompanyDataFormComponent } from './components/company-data-form/company-data-form.component';
import { EstateDataFormComponent } from './components/estate-data-form/estate-data-form.component';

import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MainComponent } from './components/main/main.component';
import { LooseCurrencyPipe } from './looseCurrency.pipe';
import { StripePaymentComponent } from './components/stripe-payment/stripe-payment.component';

@NgModule({
  providers: [
      CurrencyPipe,
      LooseCurrencyPipe
  ],
  declarations: [
    TrimDirective,
    PersonDataFormComponent,
    PersonFormComponent,
    CompanyFormComponent,
    CompanyDataFormComponent,
    EstateDataFormComponent,
    SidebarComponent,
    NavbarComponent,
    MainComponent,
    LooseCurrencyPipe,
    StripePaymentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatRadioModule,
    MatInputModule,
    MatSelectModule,
    MatToolbarModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
    MatSidenavModule,
    MatMenuModule,
    MatCardModule,
    MatPaginatorModule,
    FontAwesomeModule,
    MatStepperModule,
    MatExpansionModule,
    MatTabsModule,
    MatChipsModule,
    RouterModule,
    MatListModule,
    MatButtonToggleModule
  ],
  exports : [
    TrimDirective,
    MainComponent,
    SidebarComponent,
    NavbarComponent,
    PersonDataFormComponent,
    PersonFormComponent,
    CompanyFormComponent,
    CompanyDataFormComponent,
    EstateDataFormComponent,
    MatRadioModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
    MatSidenavModule,
    MatMenuModule,
    MatCardModule,
    MatSortModule,
    MatPaginatorModule,
    FontAwesomeModule,
    MatStepperModule,
    MatExpansionModule,
    MatTabsModule,
    MatChipsModule,
    RouterModule,
    MatListModule,
    MatButtonToggleModule,
    LooseCurrencyPipe,
    StripePaymentComponent
  ]
})
export class SharedModule { }
